<template>
  <div id="app">
    <div v-if="isLogin">
      <el-container :style="'height: '+pageHeight+'px'">
        <el-aside width="200px" style="background-color: #304156;overflow-x: hidden;">
          <el-menu :default-active="pageActive" style="text-align: left;width:200px;" background-color="#304156" text-color="#bfcbd9" active-text-color="#409eff">
            <el-menu-item :index="0" @click="openUrl('Home')">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu v-for="(item,index) in list" :key="item.id" :index="item.id" v-if="item.checked">
              <template slot="title"><i :class="item.icon"></i>{{item.title}}</template>
              <el-menu-item v-for="(itemc,indexc) in item.child" :key="itemc.id" :index="itemc.id" :disabled="itemc.url?false:true" :data-fname="item.title" :data-name="itemc.title" @click="openUrl(itemc.url)" v-if="itemc.checked">{{itemc.title}}</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main style="padding: 0;">
            <div class="top_box">
              <div style="flex: 1;">
                <el-breadcrumb>
                  <!-- :to="{ path: '/' }" -->
                  <el-breadcrumb-item>首页</el-breadcrumb-item>
                  <el-breadcrumb-item v-if="ftitle">{{ftitle}}</el-breadcrumb-item>
                  <el-breadcrumb-item v-if="title">{{title}}</el-breadcrumb-item>
                  <el-breadcrumb-item v-if="ctitle">{{ctitle}}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
              
              <div class="display_flex top_click ml-15" @click="Refresh">
                <i class="el-icon-refresh-left"></i>
                <div class="ml-5">刷新页面</div>
              </div>

              <div class="top_click ml-15" @click="exitOut">退出</div>
              <!-- <div class="top_name">{{username}}</div> -->
            </div>
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive" />
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" />
          </el-main>
        </el-container>
      </el-container>
    </div>
    <keep-alive v-else>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive> -->
  </div>
</template>

<script>
  import port from './api/port';
  export default {

    data () {
      return {
        pageActive:0,
        ftitle:'',
        title:'',
        list:[
        // {
        //   id:1,
        //   title:'用户管理',
        //   ischild:true,
        //   icon:'el-icon-s-custom',
        //   child:[
        //   {
        //     id:11,
        //     title:'汽车之家用户',
        //     url:'CarsUserList'
        //   },
        
        //   {
        //     id:12,
        //     title:'Fans助手用户',
        //     url:'UserList'
        //   }]
        // },{
        //   id:2,
        //   title:'舆情管理',
        //   ischild:true,
        //   icon:'el-icon-s-order',
        //   child:[{
        //     id:21,
        //     title:'帖子标签管理',
        //     url:'ArticleTipList'
        //   },{
        //     id:22,
        //     title:'特殊名词管理',
        //     url:'SpecialList'
        //   },
        //   {
        //     id:23,
        //     title:'训练样例管理',
        //     url:'TrainList'
        //   }]
        // },{
        //   id:3,
        //   title:'下载管理',
        //   ischild:true,
        //   icon:'el-icon-download',
        //   child:[{
        //     id:31,
        //     title:'舆情报告下载',
        //     url:'Export'
        //   },
        //   {
        //     id:32,
        //     title:'舆情下载记录',
        //     url:'ExportList'
        //   }]
        // },
        // {
        //   id:4,
        //   title:'消息管理',
        //   ischild:true,
        //   icon:'el-icon-s-comment',
        //   child:[{
        //     id:41,
        //     title:'舆情消息管理',
        //     url:'MessageList'
        //   }]
        // },
        // {
        //   id:5,
        //   title:'活动管理',
        //   ischild:true,
        //   icon:'el-icon-s-flag',
        //   child:[{
        //     id:51,
        //     title:'招募活动管理',
        //     url:'ActiveList'
        //   },{
        //     id:52,
        //     title:'活动认证管理',
        //     url:'ActiveApproveList'
        //   }]
        // },
        // {
        //   id:6,
        //   title:'统计管理',
        //   ischild:true,
        //   icon:'el-icon-s-marketing',
        //   child:[{
        //     id:61,
        //     title:'统计列表',
        //     url:'StatList'
        //   }]
        // },
        // {
        //   id:7,
        //   title:'文章管理',
        //   ischild:true,
        //   icon:'el-icon-tickets',
        //   child:[{
        //     id:71,
        //     title:'文章列表',
        //     url:'ArticleList'
        //   }]
        // },
        // {
        //   id:8,
        //   title:'菜单管理',
        //   ischild:true,
        //   icon:'el-icon-s-unfold',
        //   child:[{
        //     id:81,
        //     title:'菜单列表',
        //     url:'TreeList'
        //   }]
        // }
        ],
        isLogin:true,
        pageHeight:706,
        username:'请登录'
      }
    },
    computed: {

    },
    mounted(){
      window.addEventListener('resize',this.handleResize)
    },  
    watch: {
     '$route'() {

      if(localStorage.getItem('token')){
        this.isLogin=true
        // this.title=this.$route.meta.title
        var list=this.list
        if(this.$route.meta.title=='首页'){
          this.pageActive='0'
          this.ftitle=''
          this.title=''
        }else{
          for(var i=0;i<list.length;i++){
            var child=list[i].child
            for(var j=0;j<child.length;j++){
              if(child[j].title==this.$route.meta.title){
                this.pageActive=child[j].id
                this.ftitle=list[i].title
                this.title=child[j].title
              }
            }
          }
        }
        var member=JSON.parse(localStorage.getItem('member'));
        this.userid=member.id
        this.getAdminTreeList()
        this.getConfigList()
      }else{
        // this.$router.push({
        //   name: 'Login',
        // })
        this.isLogin=false
      }
      if(this.$route.path == '/wrong'){
        localStorage.clear()
        this.isLogin=false
      }

    }
  },
  created () {

    this.pageHeight= document.documentElement.clientHeight
    if(localStorage.getItem('token')){
      var member=JSON.parse(localStorage.getItem('member'));
      this.username=member.username
      this.userid=member.id
      this.isLogin=true
      this.getAdminTreeList()
      this.getConfigList()
    }else{
      this.$router.push({
        name: 'Login',
      })
      this.isLogin=false
    }

  },
  methods: {
   handleResize(){
    this.pageHeight= document.documentElement.clientHeight
  },
  openUrl(url){
      // console.log(url)
      // this.ftitle=event.currentTarget.dataset.fname
      // this.title=event.currentTarget.dataset.name
      this.$router.push({
        name: url,
        params: {url:url,scene: new Date().getTime()}
      })

    },
    getAdminTreeList(){
      port.getAdminTreeList({id:this.userid}).then(res => {
        if(res.data.state == 1) {
          this.list=res.data.data.list
        }
      })
    },
    getConfigList(){
      console.log('app-getConfigList')
      port.getConfigList().then(res => {
        if(res.data.state == 1) {
          localStorage.setItem("configlist",JSON.stringify(res.data.data.list));
        }
      })
    },
    //退出
    exitOut(){
      localStorage.clear()
      this.isLogin=false
      this.$router.push({
        name: 'Login',
      })
    },
    Refresh(){
      location.reload();
    },
  }

}
</script>

<style lang="scss">
  body{
    margin:0;
    overflow: hidden;
  }
  
  .wordSet{
    color: #0099cc;
    cursor:pointer
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    .el-submenu .el-menu-item{
      background-color: #1f2d3d!important;
    }
  }
  .top_box{
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #d8dce5;
    // box-shadow: 0 1px 3px 0 rgb(0 0 0 / 12%), 0 0 3px 0 rgb(0 0 0 / 4%);
    .top_click{
      font-weight:bold;
      font-size: 14px;
      text-align: right;
      cursor: pointer;
    }
    .top_name{
      font-size: 16px;
      font-weight: bold;
      margin-left: 30px;
      margin-right: 30px;
    }
  }
  .home_box{
    .top_box{
      width: 100%;
      height: 50px;
      color: #fff;
      background-color: #000;
      display: flex;
      align-items: center;
      justify-content: right;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9999;
      .top_click{
        cursor:pointer;
        font-size: 14px;
        flex: 1;
        text-align: right;
      }
      .top_click:hover{
        cursor:pointer;
      }
      .top_name{
        font-size: 16px;
        font-weight: bold;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
    .menu_box{
      height: 800px;
      text-align: left;
      overflow: auto;
      text-align: left;
    }
    .index{
      float: left;
      padding:15px;
      margin-left: 30px;
    }

  }
  .clickTable{
    position: absolute; 
    top: 0; 
    right: 0; 
    left: 0; 
    bottom: 0; 
    display: flex; 
    align-items: center; 
    justify-content: center;
  }
  .blue {
    color: #2d8cf0;
    padding-left: 5px;
  }
  .green {
    color: #67c23a;
  }
  .red {
    color: #f56c6c;
  }
  .tx-right {
    text-align: right;
    font-size: 12px;
  }
  .ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsis-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsis-3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ellipsis-4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .display_flex{
    display: flex;
    align-items: center;
  }
  .ml-15{
    margin-left: 15px;
  }
  .ml-5{
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue